import { useEffect, useState } from 'react';
import { TableCollapseCustom } from '../../../component/table/table-collapse/TableCollapseCustom';
import SearchField from '../../../phan-he-kham-benh/tabs/tab-thuoc/components/table-don-thuoc/SearchField';
import PaymentTotal from '../../../phan-he-vien-phi/components/PaymentInfor';
import { SERVICE_COLUMNS } from '../../columns';
import { usePhanHeBaoHiemYTeContext } from '../../contexts';
import { getInsuranceServices } from '../../services';

const ServiceInfo = () => {
	const { patientInfo } = usePhanHeBaoHiemYTeContext();
	const [tableData, setTableData] = useState([]);
	const [totalPayment, setTotalPayment] = useState<any>();

	useEffect(() => {
		if (patientInfo?.visitCode) {
			getServices(patientInfo?.visitCode);
		}
	}, [patientInfo?.visitCode]);

	const getServices = async (visitCode: string) => {
		try {
			const { data } = await getInsuranceServices(visitCode);

			setTableData(
				data.orderData.map((term: any) => ({
					name: term.termClassName,
					id: term.termClassId,
					subs: term.orderData.map((sub: any) => ({
						...sub,
						name: (
							<div className="d-flex">
								{sub?.isPaid ? (
									<span className="background-color-blue icon-circle-check spaces min-w-17">
										<i className="bi-check icon-check me-2"></i>
									</span>
								) : (
									''
								)}
								<span className='spaces pl-5'>{sub?.termSvcName}</span>
							</div>
						),
					})),
				}))
			);
			setTotalPayment([
				{
					name: 'Tổng chi phí',
					value: data.ttTong,
					type: 'price',
					color: 'text-success',
				},
				{
					name: 'BHYT',
					value: data.ttBhyt,
					type: 'price',
				},
				{
					name: 'BN cùng chi trả',
					value: data.ttBncct,
					type: 'price',
				},
				{
					name: 'BN thanh toán',
					value: data.ttNguoiBenh,
					type: 'price',
				},
				{
					name: 'Đã thu',
					value: data.ttDaThu,
					type: 'price',
				},
				{
					name: 'Còn nợ',
					value: data.ttConNo,
					type: 'price',
					color: 'text-danger',
				},
			]);
		} catch (error) {
			console.error(error);
		}
	};

	const onSearch = (params: any) => {};

	return (
		<div className="spaces px-4">
			<SearchField onSearch={onSearch} />
			<TableCollapseCustom
				columns={SERVICE_COLUMNS}
				data={tableData}
				className="overflow-auto"
				minHeight={300}
				maxHeight={400}
				childrenField="subs"
			/>
			<PaymentTotal paymentData={totalPayment} className="pr-10" />
		</div>
	);
};

export default ServiceInfo;
